export const INPUT_LENGTH = 4
